export enum EnumScheduleReportStatus {
    Draft = 'Draft',
    Queue = 'Queue',
    Done = 'Done',
    Canceled = 'Canceled',
    Error = 'Error',
}